import React, { FC } from "react"
import { PhotoEntityProps, PhotoView } from "../../models/PhotoModel"
import { TwoRowsPhoto } from "./TwoRowsPhoto"
import { ThreeRowsPhoto } from "./ThreeRowsPhoto"
import { OnePhoto } from "./OnePhoto"
import { TwoRowsListPhoto } from "./TwoRowsListPhoto"
import { JustifyPhoto } from "./JustifyPhoto"

export type LayoutType =
  | "One"
  | "TwoRows"
  | "ThreeRows"
  | "TwoRowsList"
  | "Justify"

export type EditablePhoto = {
  editable: boolean
}

type Props = {
  layout: LayoutType
  images: PhotoEntityProps[]
  hasSpace?: boolean
  editable: boolean
  children?: any
} & EditablePhoto

export const PhotoLayout: FC<Props> = ({
  layout,
  images,
  children,
  hasSpace = true,
  editable = false
}) => {
  const photos: PhotoView[] = images.map(p => new PhotoView(p))

  let element
  if (photos.length === 1) {
    element = <OnePhoto photo={photos[0]} editable={editable} />
  } else {
    switch (layout) {
      case "One":
        // ここにはこないはず
        element = <OnePhoto photo={photos[0]} editable={editable} />
        break
      case "TwoRows":
        element = <TwoRowsPhoto photos={photos} editable={editable} />
        break
      case "ThreeRows":
        element = <ThreeRowsPhoto photos={photos} editable={editable} />
        break
      case "TwoRowsList":
        element = <TwoRowsListPhoto photos={photos} editable={editable} />
        break
      case "Justify":
        element = <JustifyPhoto photos={photos} editable={editable} />
        break
      default:
        throw new Error("no layout!")
    }
  }
  const wrapperClassNames = ["bl-photo__wrapper"]
  if (hasSpace) {
    wrapperClassNames.push("bl-photo--space")
  }
  return (
    <div className={"bl-photo__medium-size-container"}>
      <div className={wrapperClassNames.join(" ")}>
        {element}
        {children}
      </div>
    </div>
  )
}
